import {NgModule} from '@angular/core';
import {ADStModule} from './ad-st/ad-st.module';

@NgModule({
  imports: [ADStModule],
  exports: [ADStModule]
})
export class AngKitComponentModule { }
